var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParaphrase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.775 16.5955H17.875V18.3543H12.625V13.0779H14.375V15.4786C15.9762 14.1859 17 12.2161 17 10C17 6.42085 14.3225 3.45729 10.875 3.02638V1.25C15.2937 1.6897 18.75 5.43593 18.75 10C18.75 12.6294 17.595 14.9862 15.775 16.5955ZM3 10C3 7.78392 4.02375 5.80528 5.625 4.52136V6.92211H7.375V1.64573H2.125V3.40452H4.225C2.405 5.01382 1.25 7.3706 1.25 10C1.25 14.5641 4.70625 18.3103 9.125 18.75V16.9736C5.6775 16.5427 3 13.5791 3 10ZM13.71 6.57914L8.7575 11.5565L6.28125 9.06784L5.0475 10.3078L8.7575 14.0364L14.9437 7.81909L13.71 6.57914Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaphrase);
export default __webpack_public_path__ + "static/media/paraphrase.c820e4cb344918aad6bd99293939de2a.svg";
export { ForwardRef as ReactComponent };